import React from "react";
import classNames from "classnames";

import { StrainListHeaders } from "custom-types/Directus";

import ExpandableContainer from "components/botanic/ExpandableContainer";
import DirectusHtmlWrapper from "components/DirectusHtmlWrapper";
import Image from "components/Image";

export type Props = {
  hero: StrainListHeaders<string> | null;
  displayTitle: string;
  textContainerStyle?: string;
};

const StrainListHeader: React.FunctionComponent<Props> = ({
  hero,
  displayTitle,
  textContainerStyle,
}: Props) => {
  const { hero_image, description, mobile_hero_image } = hero || {};

  return (
    <div className="relative">
      {hero_image && (
        <div className="relative" style={{ height: 300, zIndex: -1 }}>
          <Image
            src={hero_image}
            sizes={[544, 767, 1023, 1440, null, 767]}
            alt=""
            disableLazyLoad={true}
            background={true}
            {...(mobile_hero_image && { mobileSrc: mobile_hero_image })}
          />
        </div>
      )}
      <div
        className={classNames("container", {
          "mt-xxl": !hero_image,
        })}
      >
        <div
          style={{
            marginTop: hero_image ? (description ? "-100px" : "-30px") : 0,
          }}
          className={classNames(
            { "justify-end relative row": !textContainerStyle },
            textContainerStyle,
          )}
        >
          <div
            className={classNames("col bg-white rounded z-50 ", {
              "md:col-3/4": !textContainerStyle,
              "p-lg pb-0 md:px-xxl md:pt-xl": !!hero_image,
            })}
          >
            <h1 className="mb-lg">{displayTitle}</h1>
            {description && (
              <ExpandableContainer
                buttonAriaLabel="Read more"
                showMoreText="Read more"
                showLessText="Read less"
                initialHeight="96px"
              >
                <DirectusHtmlWrapper
                  data-testid="hero-description"
                  content={description}
                />
              </ExpandableContainer>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrainListHeader;
